import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import NewsletterForm from '@/pages/home/components/NewsletterForm';

export default function LatestArticles() {
  const latestArticles = articles.filter((a) => !a.isTop).slice(0, 10);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-timer-line text-accent-500 text-xl"></i>
            </div>
            <h2 className="text-lg font-heading font-bold text-foreground-200">
              最新爆料
            </h2>
          </div>

          <div className="flex flex-col gap-4">
            {latestArticles.map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex flex-col sm:flex-row gap-4 p-4 bg-background-100 border border-background-300/60 rounded-xl hover:border-primary-500/30 transition-all cursor-pointer"
              >
                <div className="relative w-full sm:w-48 h-32 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  {index === 0 && (
                    <div className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">
                      最新
                    </div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors line-clamp-2 leading-relaxed mb-1.5">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex flex-wrap items-center gap-3">
                    <Link
                      to={`/category/${article.categorySlug}`}
                      className="px-2 py-0.5 bg-secondary-100/50 text-secondary-400 text-xs rounded-full hover:bg-secondary-200/50 transition-colors whitespace-nowrap cursor-pointer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {article.categoryName}
                    </Link>
                    <span className="text-xs text-foreground-600 whitespace-nowrap">
                      <i className="ri-time-line mr-1"></i>{article.publishedAt}
                    </span>
                    <span className="text-xs text-foreground-600 whitespace-nowrap">
                      <i className="ri-eye-line mr-1"></i>{(article.views / 10000).toFixed(1)}万
                    </span>
                    <span className="text-xs text-foreground-600 whitespace-nowrap">
                      <i className="ri-chat-3-line mr-1"></i>{article.comments}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-6 text-center">
            <Link
              to="/category/daily-fresh"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-200/50 text-foreground-300 text-sm font-medium rounded-full hover:bg-background-300/50 transition-colors whitespace-nowrap cursor-pointer"
            >
              加载更多爆料
              <i className="ri-arrow-down-line"></i>
            </Link>
          </div>
        </div>

        <div className="lg:col-span-1">
          <NewsletterForm />

          <div className="mt-6 bg-background-100 border border-background-300/60 rounded-xl p-5">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-bar-chart-line text-secondary-400 text-lg"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-200">
                阅读排行
              </h3>
            </div>
            <div className="flex flex-col gap-3">
              {articles
                .sort((a, b) => b.views - a.views)
                .slice(0, 5)
                .map((a, i) => (
                  <Link
                    key={a.id}
                    to={`/article/${a.id}`}
                    className="flex items-start gap-3 group cursor-pointer"
                  >
                    <span
                      className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${
                        i < 3
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-200 text-foreground-500'
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="text-sm text-foreground-400 group-hover:text-primary-400 transition-colors line-clamp-2 leading-relaxed">
                      {a.title}
                    </span>
                  </Link>
                ))}
            </div>
          </div>

          <div className="mt-6 bg-background-100 border border-background-300/60 rounded-xl p-5">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-price-tag-3-line text-accent-400 text-lg"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-200">
                热门标签
              </h3>
            </div>
            <div className="flex flex-wrap gap-2">
              {Array.from(new Set(articles.flatMap((a) => a.tags)))
                .slice(0, 12)
                .map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1.5 bg-background-200/50 text-foreground-500 text-xs rounded-full hover:bg-secondary-200/50 hover:text-secondary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    #{tag}
                  </span>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}